<template>
  <div class="app-tariff-options-wrapper">
    <div class="booked-tariff-options" v-if="fullBookedTariffoptions.length > 0">
      <slot name="txtBeforeBooked" >Meine Tarifoptionen</slot>
      <tariff-options-list
        :options = fullBookedTariffoptions
        :clicked = clickedBooked
        :view = "'box'"
        @details="detailsBookedAction"
        :ccs92037= "'show'"
      ></tariff-options-list>
    </div>
    <div class="bookable-tariff-options" v-if="fullBookableTariffoptions.length > 0">
      <slot name="txtBeforeBookable">Buchbare Tarifoptionen</slot>
      <tariff-options-list
        :options = fullBookableTariffoptions
        :clicked = clickedBookable
        :view = "'box'"
        @details="detailsBookableAction"
      ></tariff-options-list>
    </div>
    <div class="bookable-service-options" v-if="fullBookableServiceoptions.length > 0">
      <slot name="txtBeforeBookableService">Buchbare Services</slot>
      <tariff-options-list
        :options = fullBookableServiceoptions
        :clicked = clickedService
        :view = "'box'"
        :type="'service'"
        @details="detailsBookableServiceAction"
      ></tariff-options-list>
    </div>
    <TariffOptionModalWrapper
      ref="modalAction"
      @refresh="refreshQuery"
      @close="emptyClicked"
    >
      <template v-for="slot in possibleChildSlotsFor('ModalWrapper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </TariffOptionModalWrapper>
    <ServiceModalWrapper
      ref="modalServiceAction"
      @refresh="refreshQuery"
      @close="emptyClicked"
    >
      <template v-for="slot in possibleChildSlotsFor('ModalServiceWrapper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ServiceModalWrapper>
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import slotProxy from '@/mixins/slotProxy'
import TariffOptionsList from '@/components/process/generic/Tariff/generic/TariffOptions/TariffOptionsList.vue'
import TariffOptionModalWrapper from '@/components/process/generic/Tariff/generic/TariffOptions/TariffOptionModalWrapper.vue'
import ServiceModalWrapper from '@/components/process/generic/Tariff/generic/ServiceOptions/ServiceModalWrapper.vue'
import extraData from '@/mixins/extraData'
import joinTariffOptionsExtra from '@/helper/joinTariffOptionsExtras'
import transaction from '@/mixins/transaction'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TariffOptionsWrapper',
  components: { TariffOptionModalWrapper, TariffOptionsList, ServiceModalWrapper },
  data () {
    return {
      selectedOptions: [],
      activeTariffoptionId: '',
      tariffoptions: {
        bookedTariffoptions: {
          bookedTariffoptions: []
        },
        bookableTariffoptions: {
          bookableTariffoptions: []
        }
      },
      serviceOptions: {
        tariffoptionId: ''
      },
      clickedBooked: [],
      clickedBookable: [],
      clickedService: []
    }
  },
  computed: {
    fullBookedTariffoptions: function () {
      return this.tariffoptions.bookedTariffoptions.bookedTariffoptions.map(tariffOption => {
        return joinTariffOptionsExtra(tariffOption, this.extraData)
      })
    },
    fullBookableTariffoptions: function () {
      return this.tariffoptions.bookableTariffoptions.bookableTariffoptions.map(tariffOption => {
        return joinTariffOptionsExtra(tariffOption, this.extraData)
      })
    },
    fullBookableServiceoptions: function () {
      const option = {
        ...this.serviceOptions,
        tariffoptionId: 'so_acr'
      }
      return [option].map(serviceOption => {
        return joinTariffOptionsExtra(serviceOption, this.extraData)
      })
    },
    doubleDataPromo: function () {
      return [
        'CCS_92055',
        'CCS_92056',
        'CCS_92057'
      ]
    },
    ...mapGetters('bookTariffOptions', [
      'bookTariffoptionDocumentUrl'
    ])
  },
  methods: {
    ...mapActions('bookTariffOptions', [
      'bookTariffoption',
      'initiateCancelTariffOption'
    ]),
    detailsBookedAction (optionId) {
      this.clickedBooked.push(optionId)
      const option = this.fullBookedTariffoptions.find(op => {
        return (op.tariffoptionId === optionId)
      })
      if (option.automaticExtension === true && option.cancelable === true && option.statusKey !== 'TER' && !this.doubleDataPromo.includes(optionId)) {
        this.initiateCancelTariffOption({ tariffoptionId: optionId }).then((success) => {
          if (success) {
            this.$refs.modalAction.showBookedModal(optionId, this.fullBookedTariffoptions, this.bookTariffoptionDocumentUrl)
          }
        })
      } else {
        this.$refs.modalAction.showBookedModal(optionId, this.fullBookedTariffoptions, null)
      }
    },
    detailsBookableAction (optionId) {
      this.clickedBookable.push(optionId)
      this.bookTariffoption({ tariffoptionId: optionId })
        .then((response) => {
          if (response.success === true) {
            this.$refs.modalAction.showBookingModal(response, optionId, this.fullBookableTariffoptions)
          }
        })
    },
    detailsBookableServiceAction (optionId) {
      this.clickedService.push(optionId)
      this.$refs.modalServiceAction.showBookableServiceModal(optionId, this.fullBookableServiceoptions)
    },
    refreshQuery () {
      this.emptyClicked()
      this.$apollo.queries.tariffoptions.refetch()
    },
    emptyClicked () {
      this.clickedService = []
      this.clickedBookable = []
      this.clickedBooked = []
    }
  },
  apollo: {
    tariffoptions: function () {
      return wrapQuery(
        gql`query tariffOptions {
           tariffoptions {
            bookableTariffoptions {
              bookableTariffoptions {
                bandwidth {
                down
                formattedUnit
                up
                unit
                }
                requiresContractSummary
                additionalInfo
                automaticExtension
                buttonText
                details
                formattedPrice
                name
                tariffoptionId
                name
                price
                duration {
                  amount
                  unit
                }
                notBookableWith
              }
            }
            bookedTariffoptions {
              bookedTariffoptions {
                bandwidth {
                  down
                  formattedUnit
                  up
                  unit
                }
                automaticExtension
                tariffoptionId
                name
                price
                duration {
                  amount
                  unit
                }
                statusKey
                startOfRuntime
                endOfRuntime
                possibleChangingDate
                buttonText
                cancelable
                formattedPrice
                restrictedService
                tariffState
              }
            }
           }
        }`, this, 'tariffoptions'
      )
    },
    serviceOptions: function () {
      return wrapQuery(
        gql`query serviceOptions {
          serviceOptions {
            anonymousCallRejection
          }
        }`, this, 'serviceOptions'
      )
    }
  },
  mixins: [
    slotProxy(),
    extraData(),
    transaction('tariffOptions'),
    transaction('serviceOptions')
  ]
}
</script>
